<template>
    <div class="container-fluid">
        <div class="container">
            <div class="row mb-1">
              <div class="col-sm text-start pb-1 ">
                <span class="badge rounded-pill pull-left mt-1 py-2 px-4" style="font-size:18px; background:DeepSkyBlue;">
                        <b>Cover Sheet : ใบนำส่ง</b>
                </span>
                <div class="form-check form-check-inline ms-5 p-2" title="All Type">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio1">All</label>
                </div>
                <div class="form-check form-check-inline ms-4 p-2" title="SARS-CoV-2">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio2">RT-PCR</label>
                </div>
                <div class="form-check form-check-inline ms-4 p-2" title="ATK Rapid Test">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="3" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio3">ATK</label>
                </div>
              </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm">
                        <!-- สาขาแล็บ -->
                        <div class="input-group input-group-sm">
                          <span class="input-group-text">สาขา *</span>
                          <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID">
                              <option disabled value="">Please select one</option>
                              <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm">
                        <!-- วันที่ใบสั่งตรวจ -->
                        <div class="input-group input-group-sm">
                          <span class="input-group-text">วันที่เอกสาร *</span>
                          <v-date-picker mode="date" v-model="dateFm">
                              <template v-slot="{ inputValue, inputEvents }">
                                  <input name="dateFm" ref="DateFm"
                                  class="bg-white border px-2 py-1 rounded"
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  />
                              </template>
                          </v-date-picker>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-5">
                    <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text" style="width:120px;">L.N. From - To :</span>
                        <input type="text" class="form-control form-control-sm" v-model="DocFm"
                            ref="DocFm" name="" id="RONoFm" title="ระบุเลขที่เอกสารเริ่มต้น">
                        <input type="text" class="form-control form-control-sm" v-model="DocTo"
                            ref="DocTo" name="" id="RONoTo" title="ระบุเลขที่เอกสารสิ้นสุด">
                    </div>
                </div>
                <div class="col text-start">
                    <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="btnGetROEodReport_Clicked()">ดึงข้อมูลใบนำส่ง</button>
                </div>
            </div>
        </div>
        <br>
        <div class="container">
          <button class="btn btn-primary mx-1 mb-2 float-start" @click="btnPrintROEodReport_Clicked()" v-if="dataROEodLists!==null">พิมพ์ข้อมูลใบนำส่งห้องแล็บ</button>
          <button class="btn btn-warning mx-1 mb-2 float-start" @click="btnPrintAcctReport_Clicked()" v-if="dataROEodLists!==null">พิมพ์ข้อมูลใบนำส่งแผนกบัญชี</button>
        </div>
        <!-- ตารางพิมพ์ไปห้องแล็บ -->
        <div id="divToPrint" class="container">
            <table id="myLabReqTable" data-pdfmake="{'headerRows': 1}"
              class="table table-sm table-hover table-striped table-bordered">
                <thead>
                <tr class="bg-dark text-white">
                    <th style="width:20px;">No.</th>
                    <th style="width:80px; text-align:center;">เลขที่ใบตรวจ</th>
                    <th style="width:130px;">ชื่อ-สกุล คนไข้</th>
                    <th style="text-align:center; width:150px;">Barcode</th>
                    <th style="width:30px;">เพศ</th>
                    <th style="width:40px;">อายุ(ปี)</th>
                    <th style="width:100px;">Specimen</th>
                    <th style="width:100px;">ประเภทการตรวจ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in dataROEodLists" :key="item.ROID" v-bind:data-id="item.ROID" @click="tableChanged(item)">
                    <td class="" >{{ index + 1 }}.</td>
                    <td class="text-start" >{{ item.RONo }}</td>
                    <td class="text-start" >{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="text-start" > <img :src="textToBase64Barcode(item.RONo)" alt="Red dot" style="width:150px;height:45px;" /> </td>
                    <td class="" style="text-align:center;">{{ arrSex[item.Sex] }}</td>
                    <td class="" style="text-align:center;">{{ item.AgeYears }}</td>
                    <td class="text-start" >{{item.Specimen}}</td>
                    <td class="text-start" >{{item.Test}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <!-- ตารางพิมพ์ไปแผนกบัญชีและการเงิน -->
        <div id="divToPrintAcct" class="container" hidden>
            <table id="myLabReqTable" data-pdfmake="{'headerRows': 1}"
              class="table table-sm table-hover table-striped table-bordered">
                <thead>
                <tr class="bg-dark text-white">
                    <th style="width:20px;">No.</th>
                    <th style="width:80px; text-align:center;">เลขที่ใบตรวจ</th>
                    <th style="width:130px;">ชื่อ-สกุล คนไข้</th>
                    <th style="width:30px;">เพศ</th>
                    <th style="width:30px; text-align: center;">อายุ (ปี)</th>
                    <th style="width:100px;">ประเภทการตรวจ</th>
                    <th style="width:150px;">หน่วยงานบริษัท</th>
                    <th style="width:40px; text-align: center;">ชำระ</th>
                    <th style="width:50px; text-align: right;">สุทธิ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in dataROEodLists" :key="item.ROID" v-bind:data-id="item.ROID" @click="tableChanged(item)">
                    <td class="" >{{ index + 1 }}.</td>
                    <td class="text-start" >{{ item.RONo }}</td>
                    <td class="text-start" >{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="" style="text-align:center;">{{ arrSex[item.Sex] }}</td>
                    <td class="" style="text-align:center;">{{ item.AgeYears }}</td>
                    <td class="text-start" >{{item.Test}}</td>
                    <td class="text-start" >{{item.ReqClinicName}}</td>
                    <td style="text-align: center;">{{ arrPayType[item.PayType] }}</td>
                    <td style="text-align: right;">{{ numeralFormat(item.NetAmt, '0,0[.]00') }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import JsBarcode from 'jsbarcode/bin/JsBarcode'
import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabCreate',
  data () {
    return {
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต', 'เงินโอน'],
      // เงื่อนไขสำหรับออกรายงานสรุปใบนำส่ง
      dataROEodLists: [],
      DocFm: '0000-000000',
      DocTo: '9999-999999',
      TestType: 1, // 1-All  2-RT PCR  3-ATK
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null
    }
  },
  created () {
    this.getBranchData()
  },
  mounted () {
    this.branchID = this.globalBranchID
  },
  components: {

  },
  methods: {
    btnPrintAcctReport_Clicked () {
      this.createPdfAcctToScreen()
    },
    createPdfAcctToScreen () {
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrintAcct')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      console.log(html)
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, 105, 20, 120],
        header: [
          {
            text: 'รายงานส่งตรวจทางห้องปฏิบัติการ (แผนกบัญชีและการเงิน)',
            alignment: 'center',
            fontSize: 16,
            bold: true,
            margin: [0, 30, 0, 5]
          },
          {
            margin: [20, 0, 20, 5],
            table: {
              widths: [80, 200, 80, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'จากสาขา : ' },
                  { text: this.dataBranchlists[this.dataBranchlists.map(function (item) { return item.BranchID }).indexOf(this.globalBranchID)].BranchName, bold: true },
                  { text: 'วันที่ส่งสิ่งส่งตรวจ : ' },
                  { text: new Date().toJSON().slice(0, 10).replace(/-/g, '/'), bold: true }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: 'รายการทั้งหมด :' },
                  { text: this.dataROEodLists.length, bold: true },
                  { text: 'เวลา :' },
                  { text: new Date().toLocaleTimeString(), bold: true }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 10, 20, 20],
            table: {
              widths: [260, 260],
              body: [
                [
                  {
                    text: 'ผู้นำส่ง(ต้นทาง) \n\n _____________________________________\n',
                    alignment: 'center',
                    fontSize: 14
                  },
                  {
                    text: 'ผู้ตรวจสอบ(ปลายทาง) \n\n _____________________________________\n',
                    alignment: 'center',
                    fontSize: 14
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        },
        content: html,
        style: {

        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 14
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    btnPrintROEodReport_Clicked () {
      this.createPdfROEodToScreen()
    },
    createPdfROEodToScreen () {
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      // console.log(html)
      var documentDefinition = {
        pageSize: 'A4',
        // pageOrientation: 'landscape',
        pageMargins: [20, 105, 20, 120],
        header: [
          {
            text: 'แบบขอส่งตรวจทางห้องปฏิบัติการ',
            alignment: 'center',
            fontSize: 16,
            bold: true,
            margin: [0, 30, 0, 5]
          },
          {
            margin: [20, 0, 20, 5],
            table: {
              widths: [80, 200, 80, '*'],
              body: [
                // ============ แถวที่ 1 ============
                [
                  { text: 'จากสาขา : ' },
                  { text: this.dataBranchlists[this.dataBranchlists.map(function (item) { return item.BranchID }).indexOf(this.globalBranchID)].BranchName, bold: true },
                  { text: 'วันที่ส่งสิ่งส่งตรวจ : ' },
                  { text: new Date().toJSON().slice(0, 10).replace(/-/g, '/'), bold: true }
                ],
                // ============ แถวที่ 2 ============
                [
                  { text: 'รายการทั้งหมด :' },
                  { text: this.dataROEodLists.length, bold: true },
                  { text: 'เวลา :' },
                  { text: new Date().toLocaleTimeString(), bold: true }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        ],
        footer: function (currentPage, pageCount) {
          return {
            margin: [20, 10, 20, 20],
            table: {
              widths: [260, 260],
              body: [
                [
                  {
                    text: 'ผู้นำส่ง(ต้นทาง) \n\n _____________________________________\n',
                    alignment: 'center',
                    fontSize: 14
                  },
                  {
                    text: 'ผู้ตรวจสอบ(ปลายทาง) \n\n _____________________________________\n',
                    alignment: 'center',
                    fontSize: 14
                  }
                ],
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: {
              defaultBorder: false
            }
          }
        },
        content: html,
        style: {

        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 14
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    textToBase64Barcode (text) {
      var canvas = document.createElement('canvas')
      // var canvas = document.getElementById('2108-000008')
      JsBarcode(canvas, text, { width: 4, height: 70 })
      var canvasDataURL = canvas.toDataURL('image/png')
      return canvasDataURL
    },
    btnGetROEodReport_Clicked () {
      if (!(this.branchID > 0)) {
        this.$refs.BranchID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "สาขา" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.dateFm === null)) {
        this.$refs.DateFm.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "วันที่เอกสาร" ของเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.DocFm === '')) {
        this.$refs.DocFm.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เลขที่ที่เอกสารเริ่มต้น" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.DocTo === '')) {
        this.$refs.DocTo.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เลขที่ที่เอกสารสิ้นสุด" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      this.getROEodData()
    },
    getROEodData () {
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDate = YYYY + '-' + MM + '-' + DD
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labrequest_cover_sheet.php?C1=' + this.globalCorpID + '&BranchID=' + this.branchID +
        '&DateFm=' + docDate + '&DocFm=' + this.DocFm + '&DocTo=' + this.DocTo + '&TestType=' + this.TestType)
        .then((resp) => {
          // console.log('REFRESH : ')
          // console.log(resp.data.response)
          this.dataROEodLists = resp.data.response
          if (this.dataROEodLists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
